/* eslint-disable jsx-a11y/no-onchange */
import React from 'react';
import PropTypes from 'prop-types';
import ValidationErrorLabel from '../ValidationErrorLabel';
import './radio-group.scss';

import {
  DivStyled,
  FieldsetStyled,
  RadioLabelStyled,
  RadioLabelGroupStyled,
} from './styles';

export const RadioComponent = ({
  label, required, radioValues, name, onChange, error, errorMessage, disabled,
}) => (
  <DivStyled className='nmx-form__input' role='radiogroup'>
    {label}{required && <span>&#42;</span>}
    <FieldsetStyled aria-required={required}>
      <legend>{label}</legend>
      {
        radioValues.map((radioValue, index) => (
          <RadioLabelGroupStyled aria-label={radioValue} key={radioValue} index={index}>
            <RadioLabelStyled className='nmx-form__radio-button-label'>{radioValue}</RadioLabelStyled>
            <input
              type='radio'
              name={name}
              disabled={disabled}
              value={radioValue}
              onChange={onChange}
            />
          </RadioLabelGroupStyled>
        ))
      }
      <ValidationErrorLabel error={error} errorMessage={errorMessage} />
    </FieldsetStyled>
  </DivStyled>
);

RadioComponent.propTypes = {
  /** The label placed on the text field */
  label: PropTypes.string.isRequired,
  /** Name applied to input or textarea */
  name: PropTypes.string.isRequired,
  /** String array of radio buttons for group, each string is used as both the display label and value */
  radioValues: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  /** Is this input in an error state */
  error: PropTypes.bool,
  /** Message to display when error is true */
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
};

RadioComponent.defaultProps = {
  radioOptions: [],
  onChange: () => {},
  disabled: false,
  error: false,
  errorMessage: 'Error',
  required: false,
};

export default RadioComponent;
